import { get, post, put, del } from './https';

export interface HomeSection {
  key: string;
  type: string;
  order: number;
  isActive: boolean;
  bannerDisplay?: string;
}

export interface HomeConfig {
  _id?: string;
  appType: 'USER' | 'TECHNICIAN';
  screen: string;
  sections: HomeSection[];
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

const BASE = '/api/v1/home/config';

// Enums mirror the backend HomeScreenConfig model exactly.
export const SECTION_KEYS = [
  'TOP_BANNER',
  'SERVICE_TYPES',
  'REQUEST',
  'UTILITIES',
  'MIDDLE_BANNER',
  'PRODUCT_LIST',
  'STERILIZATION_INFO',
  'BOTTOM_BANNER',
  'INPUT',
  'EXTRA_IMAGE',
];

export const SECTION_TYPES = ['BANNER', 'DASHBOARD', 'PRODUCT_LIST', 'INFO', 'TEXT'];

export const BANNER_DISPLAYS = ['CAROUSEL', 'STATIC', 'AUTO'];

export const APP_TYPES = ['USER', 'TECHNICIAN'];

export const getHomeConfigs = async (params?: {
  appType?: string;
  screen?: string;
}): Promise<HomeConfig[]> => {
  const q = new URLSearchParams();
  if (params?.appType) q.append('appType', params.appType);
  if (params?.screen) q.append('screen', params.screen);
  const url = q.toString() ? `${BASE}?${q.toString()}` : BASE;

  const res = await get(url);
  if (res.status === 200) return res.data?.data || [];
  throw new Error('Failed to fetch home configs');
};

export const getHomeConfigById = async (id: string): Promise<HomeConfig> => {
  const res = await get(`${BASE}/${id}`);
  if (res.status === 200 && res.data?.data) return res.data.data;
  throw new Error(res.data?.message || 'Failed to fetch config');
};

export const createHomeConfig = async (payload: HomeConfig) => {
  const res = await post(BASE, payload);
  if (res.status === 200 || res.status === 201) return res.data;
  throw new Error(res.data?.message || 'Failed to create config');
};

export const updateHomeConfig = async (
  id: string,
  payload: Partial<HomeConfig>,
) => {
  const res = await put(`${BASE}/${id}`, payload);
  if (res?.success) return res;
  throw new Error(res?.message || 'Failed to update config');
};

export const deleteHomeConfig = async (id: string) => {
  const res = await del(`${BASE}/${id}`);
  if (res?.success) return res;
  throw new Error(res?.message || 'Failed to delete config');
};
